import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { type AppSettings } from './app-settings.model';
import { SettingsService } from './settings.service';

/**
 * Registers the already resolved runtime config. Goes first in the provider
 * list, ahead of provideHttpClient, because the interceptors resolve services
 * that read settings.
 */
export function provideAppSettings(settings: AppSettings): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: SettingsService, useFactory: () => new SettingsService(settings) },
  ]);
}
